import { render, staticRenderFns } from "./advert-not-found.vue?vue&type=template&id=56af69f8"
import script from "./advert-not-found.vue?vue&type=script&lang=ts"
export * from "./advert-not-found.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports